.breakAll {
  word-break: break-all;
}

.whiteSpacePreWrap {
  white-space: pre-wrap;
}

.nowrap {
  white-space: nowrap;
}

.red {
  color: var(--x-color-text-red);
}

.green {
  color: var(--x-color-text-green);
}

.orange {
  color: var(--x-color-text-orange);
}

.violet {
  color: var(--x-color-text-violet);
}

.accent {
  color: var(--x-color-text-accent);
}

.secondary {
  color: var(--x-color-text-secondary);
}

.crossed {
  text-decoration: line-through;
}

.underline {
  text-decoration: underline;
}

.capitalize {
  text-transform: capitalize;
}

.semibold {
  font-weight: 600;
}

.bold {
  font-weight: 700;
}

/* stylelint-disable selector-class-pattern */

.title-h1-l {
  .text-title-h1-l();
}

.title-h1-m {
  .text-title-h1-m();
}

.title-h1-s {
  .text-title-h1-s();
}

.title-h2 {
  .text-title-h2();
}

.title-h3 {
  .text-title-h3();
}

.title-h4 {
  .text-title-h4();
}

.title-h5 {
  .text-title-h5();
}

.title-h6 {
  .text-title-h6();
}

.subtitle-l {
  .text-subtitle-l();
}

.subtitle-m {
  .text-subtitle-m();
}

.subtitle-s {
  .text-subtitle-s();
}

.subtitle-xs {
  .text-subtitle-xs();
}

.body {
  .text-body();
}

.body-italic {
  .text-body-italic();
}

.body-s {
  .text-body-s();
}

.body-s-italic {
  .text-body-s-italic();
}

.body-xs {
  .text-body-xs();
}

.body-xs-italic {
  .text-body-xs-italic();
}
/* stylelint-enable selector-class-pattern */

.ellipsis {
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
}
